import React from "react";

interface ComponentPreviewProps {
  name: string;
  preview: () => React.JSX.Element;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  onSelect: () => void;
  onDragStart: (e: React.DragEvent) => void;
}

export function ComponentPreview({
  name,
  preview: PreviewComponent,
  description,
  icon: Icon,
  onSelect,
  onDragStart,
}: ComponentPreviewProps) {
  return (
    <div
      className="w-full p-4 text-left hover:bg-muted dark:hover:bg-auth-background rounded-lg transition-colors border border-transparent hover:border-primary/20 group cursor-pointer"
      draggable
      onDragStart={onDragStart}
      onClick={onSelect}
    >
      {/* Component Preview */}
      <div className="mb-3 p-3 bg-background dark:bg-auth-card group-hover:bg-primary/5 rounded-lg border border-border/30 transition-colors min-h-[60px] flex items-center justify-center">
        <PreviewComponent />
      </div>

      {/* Component Info */}
      <div className="flex items-start space-x-3">
        <div className="w-6 h-6 bg-background dark:bg-auth-card group-hover:bg-primary/10 rounded flex items-center justify-center transition-colors flex-shrink-0 mt-0.5">
          <Icon className="w-3 h-3 text-muted-foreground group-hover:text-primary transition-colors" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium mb-1">{name}</div>
          <div className="text-xs text-muted-foreground leading-relaxed">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
}
